import { AutoComplete, ISelectType, useFormContext } from "@4uhub/lib4uhub";
import { Box, Grid, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { memo, useCallback, useMemo, useState } from "react";
import KeyValueButtons from "./KeyValueButtons";
import MainApi from "../../../../../../services/mainApi.service";
import { useTranslation } from "react-i18next";
import { TProtocolDefaultForm } from "./ProtocolDefaultSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.settings.crm.protocolsDefault.";
const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";

const genericService = new MainApi(GENERICS_ROUTE);
export const TicketDefaultDocButtons = memo(() => {
  const { control, setValue } = useFormContext<TProtocolDefaultForm>();
  const { t } = useTranslation();

  const handleButtonTypeChange = useCallback((value: ISelectType | null) => {
    setValue("ticketDefaultDocButtons", []);
  }, []);

  const ticketDefaultDocButtonType = useWatch({
    name: "ticketDefaultDocButtonType",
    control,
  });

  const ticketDefaultDocButtonTypeParams = useMemo(
    () => ({ Identifier: "TicketDefaultDocButtonType" }),
    []
  );

  return (
    <>
      <Grid item xs={12} sm={12}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: "#FEFF99",
            color: (t) => t.palette.warning.dark,
            p: 1.5,
            borderRadius: 1,
            border: (t) => `1px solid ${t.palette.warning.main}`,
          }}
        >
          <WarningAmberIcon fontSize="small" />
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {t(translationPath + "buttons_no_integligence_warning")}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          params={ticketDefaultDocButtonTypeParams}
          name="ticketDefaultDocButtonType"
          label={t(translationPath + "button_type") || "Button Type"}
          getOptionLabel={(option) => option.name}
          size="small"
          fullWidth
          request={genericService.list}
          onValueChange={handleButtonTypeChange}
        />
      </Grid>{" "}
      {ticketDefaultDocButtonType && (
        <Grid item xs={12} sm={6}>
          <KeyValueButtons
            maxItems={
              ticketDefaultDocButtonType &&
              ticketDefaultDocButtonType.code === "2"
                ? 1
                : 3
            }
          />
        </Grid>
      )}
    </>
  );
});
